import React from 'react';
import { heroTestimonials as heroQuotes } from '../data/content';
const stats = [{
  value: '+1.200',
  label: 'familias hispanohablantes'
}, {
  value: '5',
  label: 'Tomos listos'
}, {
  value: '5',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}];
export function HeroProof() {
  return <section className="w-full bg-ink-950 py-12" aria-label="Resultados y testimonios" style={{
    paddingTop: "15px",
    paddingBottom: "15px"
  }} data-id="element-116" data-mp="1au874p4qemrr">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6" data-id="element-117" data-mp="i4j3s54juamz">
        <dl className="grid grid-cols-2 gap-x-6 gap-y-5 border-y border-ink-800 py-6 text-center sm:grid-cols-4" data-id="element-118" data-mp="i62me2dogxrx">
          {stats.map(stat => <div key={stat.label} data-id="element-119" data-mp="s2p44iapj8pq">
              <dt className="sr-only" data-id="element-120" data-mp="s2f9uiimqfe8">{stat.label}</dt>
              <dd data-id="element-121" data-mp="s0ui10np9ak2">
                <span className="block font-display text-2xl font-800 text-white" data-id="element-122" data-mp="4cuu08hrvy96">
                  {stat.value}
                </span>
                <span className="mt-0.5 block text-xs leading-snug text-slate-400" data-id="element-123" data-mp="3vimfguklumpn">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <ul className="mt-10 grid gap-3 md:grid-cols-3" data-id="element-124" data-mp="1agt9vtfqr5fr">
          {heroQuotes.map(item => <li key={item.name} className="flex flex-col rounded-xl border border-ink-800 bg-ink-900 p-5" style={{
          paddingTop: "0px",
          paddingBottom: "0px",
          gap: "0px"
        }} data-id="element-125" data-mp="1f7t3aopnj5di">
              <p className="text-xs tracking-widest text-gold" aria-label="5 de 5 estrellas" data-id="element-126" data-mp="nhx02u51s9ta">
                ★★★★★
              </p>
              <p className="mt-2 text-[15px] leading-relaxed text-slate-200" data-id="element-127" data-mp="rj8poznx8v1h">“{item.quote}”</p>
              <p className="mt-auto flex items-center gap-2 pt-4 text-xs text-slate-400" data-id="element-128" data-mp="wg8ocpifyvik">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-ink-700 font-display text-[11px] font-700 text-gold" data-id="element-129" data-mp="11hplqb1pvzue">
                  {item.initials}
                </span>
                {item.name} · {item.city}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}